export const BASE_HEADER_CLASS = 'header-cell';
export const BASE_CELL_CLASS = 'cell';
